<template>
  <div>
    <vxe-grid
      ref="vxeGrid"
      auto-resize
      :loading="loading"
      highlight-hover-row
      :toolbar-config="tableToolbar"
      :data="tableData"
      :columns="tableColumns"
      :height="tableHeight - 6"
      size="small"
      resizable
      border
      :checkbox-config="{
        highlight: true,
      }"
    >
      <template v-slot:toolbar_form>
        <slot name="header">
          <b-button-group size="sm" :disabled="disabled">
            <b-button
              class="mr-2"
              variant="outline-success"
              @click="$emit('openUploadFormDialog')"
              :disabled="disabled"
            >
              <i class="el-icon-plus" />
              {{ $l('INDEX.btn_upload') || '上传' }}
            </b-button>
            <b-button
              variant="outline-danger"
              @click="batchDel()"
              :disabled="disabled"
            >
              <i class="el-icon-delete"></i>
              {{ $l('INDEX.btn_delete') || '删除' }}
            </b-button>
          </b-button-group>
        </slot>
      </template>
      <template v-slot:expandContent="{ row }">
        <GoodsSpecTable
          class="m-2"
          :orderTechDocCode="row.orderTechDocCode"
          :changeOrderCode="row.changeOrderCode"
          :disabled="disabled"
          isExpand
          @reload="$emit('reload')"
        />
      </template>
      <template v-slot:opt="{ row }">
        <div>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_edit') || '编辑'"
            placement="top"
            v-if="!disabled"
          >
            <i
              class="el-icon-edit tool-btn"
              @click="$emit('openEditFromDialog', row)"
            ></i>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_downloada') || '下载'"
            placement="top"
          >
            <i class="el-icon-download tool-btn" @click="downloadFile(row)"></i>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_del') || '删除'"
            placement="top"
            v-if="!disabled"
          >
            <i
              class="el-icon-delete tool-btn"
              @click="del(row.orderTechDocCode)"
            ></i>
          </el-tooltip>
        </div>
      </template>
      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data mt-2">
            {{ $l('INDEX.table_label_no_data') || '暂无数据！' }}
          </p>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import tableColumns from './table-columns'
import TableAutoHeight from '@/mixins/table-auto-height'
import EditLoading from '@/mixins/edit-loading'
import GoodsSpecTable from '../goods-spec'
export default {
  mixins: [TableAutoHeight, EditLoading],
  components: { GoodsSpecTable },
  props: {
    tableData: { type: Array, default: () => [] },
    loading: { type: Boolean, default: false },
    orderInspectionCode: String,
    disabled: { type: Boolean, default: false },
  },
  data() {
    return {
      tableToolbar: {
        slots: {
          buttons: 'toolbar_form',
        },
        refresh: {
          query: () => this.$emit('reload'),
        },
        zoom: true,
      },
      tableColumns: tableColumns(this),
    }
  },
  methods: {
    downloadFile({ fileCode = '' }) {
      this.$api.SYS_FILEDOWNLOAD(fileCode)
    },
    getCheckboxRecords() {
      const $vxeGrid = this.$refs.vxeGrid
      const data = $vxeGrid.getCheckboxRecords()
      if (!data || !data.length) return
      return data
    },
    del(code) {
      this.submitDel([code])
    },
    batchDel() {
      const listRow = this.getCheckboxRecords()
      if (!listRow) {
        this.$message({
          showClose: true,
          message:
            this.$l('INDEX.tips_question_del_rows') || '请选择需要删除的数据!',
          type: 'warning',
        })
        return
      }

      const listDocCode = listRow.map((i) => i.orderTechDocCode)
      this.submitDel(listDocCode)
    },
    submitDel(listDocCode) {
      if (!listDocCode || !listDocCode.length) return
      this.$confirm(
        this.$l('INDEX.tips_delete') ||
          '删除文档同时也会删除对应的产品，是否要删除该文档？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText:
            this.$l('INDEX.product_dialog_btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      ).then(() => {
        this.loadingOpen()
        this.$api
          .changeOrderTechDocBatchDelApi({ listDocCode })
          .then((res) => {
            this.loadingClose()
            const { status } = res
            if (status !== 200) {
              this.$message.error(
                this.$l('INDEX.tips_delete_no') || '删除失败！'
              )
              return
            }
            this.$message({
              message: this.$l('INDEX.tips_delete_ok') || '删除成功！',
              type: 'success',
            })
            this.$emit('reload')
          })
          .catch(() => {
            this.loadingClose()
            this.$message.error(this.$l('INDEX.tips_delete_no') || '删除失败！')
          })
      })
    },
  },
}
</script>
